import axios from 'axios';
import { AIS_REST_PATH, REPLAYS_REST_PATH } from 'configs/rest';

const exampleLink = `http://www.atgvision.com/handlers/MediaPlaylist.ashx?guid=`;

const DerbyVisionAPI = () => ({
    getUrl: () => {
        let supportedTracks;
        const isTrackSupported = (trackCode) => {
            if (!supportedTracks) {
                return false;
            }
            console.log(supportedTracks);
            return supportedTracks.some((t) => t.track.code === trackCode);
        };

        /**
         * Gets the replays using statistic data rows
         * Returns array of the links to video replays
         * @param data
         * @return {Promise<string[] | void>}
         */
        return async (data) => {
            if (!supportedTracks) {
                supportedTracks = await getSupportedTracks();
            }

            const replayLinkPromises = data.map(({ raceKey }) => {
                const { date, raceNr, track } = raceKey;

                if (!isTrackSupported(track.code)) {
                    return Promise.resolve({ data: { data: exampleLink } });
                }
                return axios.get(
                    `${REPLAYS_REST_PATH}getUrl?trackCode=${
                        track.code
                    }&date=${date}&raceNumber=${raceNr}`
                );
            });

            return Promise.all(replayLinkPromises)
                .then((responses) =>
                    responses.map((res) => {
                        const link = res.data.data;
                        const isWorkingLink = new URL(link).searchParams.get(
                            'guid'
                        );
                        return isWorkingLink ? link : null;
                    })
                )
                .catch((reason) =>
                    console.error(
                        `Could'nt get data from DerbyVision for multiple replays. ${reason}`
                    )
                );
        };
    },
    getReplayUrl: (data) => {
        const { countryCode, date, raceNumber, trackCode, trackId } = data;

        return axios.get(
            `${REPLAYS_REST_PATH}replay/url?countryCode=${countryCode}&date=${date}&raceNumber=${raceNumber}&trackCode=${trackCode}&trackId=${trackId}`
        );
    },
});

const getSupportedTracks = () =>
    axios
        .post(`${AIS_REST_PATH}getVisionTracks`)
        .then((res) => res.data.data)
        .catch((reason) =>
            console.error(
                `Could not get the list of Derby Vision supported tracks. ${reason}`
            )
        );

export default DerbyVisionAPI();
